<template>
  <v-flex
    id="specialGifts"
    class="question"
  >
    <h2
      v-if="getSpecialGiftsQuestions.hasOwnProperty('gift')"
      class="header mb-0"
      :class="{ required: getSpecialGiftsQuestions.gift.required }"
    >
      {{ getSpecialGiftsQuestions.label }}
    </h2>
    <v-layout wrap>
      <v-flex
        v-for="(representative, index) in representatives"
        :key="index"
        xs12
        class="mt-4"
      >
        <v-layout
          align-center
          :wrap="$vuetify.breakpoint.smAndDown"
        >
          <v-flex
            class="mt-4 mr-2"
            shrink
          >
            <span class="fw-600 f-2 text-dark">{{ indexNum(index) }}</span>
          </v-flex>
          <v-flex
            lg3
            md4
          >
            <v-text-field
              :label="$t('sheet.sheet_two.special_gifts.labels.name')"
              class="ml-1 personal-input_disabled personal-input_original"
              :value="representative.newName"
              disabled
            />
            <p class="mb-0 ml-3">
              {{ $t('sheet.sheet_two.original') | addColons }} {{ representative.name }}
            </p>
          </v-flex>
          <v-flex
            lg9
            md8
            sm12
            xs12
            :class="[{ 'mt-2': $vuetify.breakpoint.smAndDown }]"
          >
            <v-textarea
              v-if="getMemberByRepresentative(representative)"
              v-model="getMemberByRepresentative(representative).gift"
              v-validate="{ ...requiredRegularField(getSpecialGiftsQuestions.gift.required) }"
              :label="getSpecialGiftsQuestions.gift.label"
              :error-messages="errors.collect(createDataName('specialGift', getMemberIndexByRepresentative(representative)))"
              :data-vv-as="$t('sheet.sheet_two.special_gifts.labels.gift')"
              :data-vv-name="createDataName('specialGift', getMemberIndexByRepresentative(representative))"
              :required="getSpecialGiftsQuestions.gift.required"
              :disabled="readOnly"
              :rows="1"
              auto-grow
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        v-if="getSpecialGiftsQuestions.hasOwnProperty('gifts_notes')"
        class="mt-4"
      >
        <p
          class="fw-600 mb-0"
          :class="{ required: getSpecialGiftsQuestions.gifts_notes.required }"
        >
          {{ getSpecialGiftsQuestions.gifts_notes.label }}
        </p>
        <v-textarea
          v-model="giftsNotes"
          v-validate="{ ...requiredRegularField(getSpecialGiftsQuestions.gifts_notes.required) }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('giftsNotes')"
          :data-vv-as="' '"
          data-vv-name="giftsNotes"
          :disabled="readOnly"
          :rows="1"
          auto-grow
        />
      </v-flex>
    </v-layout>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import filters from '@/constants/filters';
import validationRules from '@/constants/validationRules';

import { mapGetters } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

const { mapFields } = createHelpers({
    getterType: 'sheet/getSpecialGiftsFields',
    mutationType: 'sheet/updateSpecialGiftsField'
});

// @TODO: I think whole component can be refactored, especially the way how we are handling the members data - preferably after Vue 3 / TS migration
export default {
    name: 'SpecialGifts',
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules,
            emptyMembersData: {
                gift: null
            }
        };
    },
    computed: {
        ...mapFields(['members', 'giftsNotes']),
        representatives () {
            return this.$store.getters['sheet/getNewNames'];
        },
        ...mapGetters('sheet', ['getSpecialGiftsQuestions'])
    },
    filters: {
        ...filters
    },
    watch: {
        representatives: {
            handler (val) {
                if (this.members.length === 0) {
                    val.forEach((el) => {
                        this.members.push({
                            id: el.id,
                            ...this.emptyMembersData
                        });
                    });
                }
                if (this.members.length < val.length) {
                    val.forEach((representative) => {
                        if (!this.getMemberByRepresentative(representative)) {
                            this.members.push({
                                id: representative.id,
                                ...this.emptyMembersData
                            });
                        }
                    });
                }
            },
            immediate: true
        }
    },
    methods: {
        indexNum (index) {
            return index + 1 + '.';
        },
        createDataName (name, id) {
            return name + id;
        },
        getMemberByRepresentative (representative) {
            return this.members.find(member => member?.id === representative?.id);
        },
        getMemberIndexByRepresentative (representative) {
            return this.members.findIndex(member => member?.id === representative?.id);
        }
    }
};
</script>

<style scoped></style>
